export default "<strong class=\"hideInResponsive\">{{ greetingLanguageLabel }},</strong>&nbsp;{{userObject?.userFirstName}}!\r\n\r\n"